import React from "react";
import PropTypes from "prop-types";
import { push } from "connected-react-router";
import CircularProgress from "@mui/material/CircularProgress";
import {
  consumeLoginLinkCode,
  readBindingSecret,
  readFreshPending,
  removePending
} from "services/loginLinkService";
import { completeLoginLink } from "./completeLoginLink";
import { renderLoginLinkCard, renderLoginLinkExpired } from "./LoginLink";

const CODE_LENGTH = 6;

class LoginLinkCode extends React.Component {
  constructor(props, context) {
    super(props, context);

    this._isMounted = false;

    this.state = {
      code: "",
      error: null,
      isSubmitting: false,
      isExpired: false
    };
  }

  componentDidMount() {
    this._isMounted = true;

    if (!readFreshPending()) {
      this.props.dispatch(push("/login"));
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleCodeChange = event => {
    this.setState({
      code: event.target.value.replace(/\D/g, "").slice(0, CODE_LENGTH)
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const { code, isSubmitting } = this.state;

    if (isSubmitting || !/^[0-9]{6}$/.test(code)) {
      return;
    }

    const pending = readFreshPending();

    if (!pending) {
      this.props.dispatch(push("/login"));
      return;
    }

    this.setState({ isSubmitting: true, error: null });

    this.props
      .dispatch(
        consumeLoginLinkCode({
          email: pending.email,
          binding_secret: readBindingSecret(),
          code
        })
      )
      .then(
        data => {
          if (this._isMounted) {
            completeLoginLink(this.props.dispatch, data);
          }
        },
        ({ statusCode, error }) => {
          if (!this._isMounted) {
            return;
          }

          if (statusCode === 422) {
            removePending();
            this.setState({ isExpired: true, isSubmitting: false });
            return;
          }

          this.setState({ isSubmitting: false, error });
        }
      );
  };

  handleBackToLogin = () => {
    this.props.dispatch(push("/login"));
  };

  render() {
    const { code, error, isSubmitting, isExpired } = this.state;

    if (isExpired) {
      return renderLoginLinkExpired(this.handleBackToLogin);
    }

    return renderLoginLinkCard(
      error,
      <form className="login-form" onSubmit={this.handleSubmit} noValidate>
        <div className="login-link-hint">
          Enter the 6-digit code shown where you opened the login link.
        </div>
        <div className="login-field">
          <div className="login-input login-code-input">
            <span className="material-icons login-input-icon">
              lock_outline
            </span>
            <input
              name="code"
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              autoComplete="one-time-code"
              aria-label="6-digit code"
              placeholder="000000"
              maxLength={CODE_LENGTH}
              value={code}
              onChange={this.handleCodeChange}
              autoFocus
            />
          </div>
        </div>
        <button
          type="submit"
          className="login-btn login-btn-primary"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            <span className="login-btn-label">Continue</span>
          )}
        </button>
      </form>
    );
  }
}

LoginLinkCode.propTypes = {
  dispatch: PropTypes.func.isRequired
};

export default LoginLinkCode;
